import { render, staticRenderFns } from "./gzzoc.vue?vue&type=template&id=755f0e8e&scoped=true&lang=pug&"
import script from "./gzzoc.vue?vue&type=script&lang=js&"
export * from "./gzzoc.vue?vue&type=script&lang=js&"
import style0 from "./gzzoc.vue?vue&type=style&index=0&id=755f0e8e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755f0e8e",
  null
  
)

export default component.exports